export default __webpack_public_path__ + "static/media/saved1.d4cdaddd.svg";